// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"487cd1fb59c0af5827fd","293":"225656d91775b5922ca8","454":"56cbc80d9f4fd9aa2460"}[chunkId] + ".js";
};